class Marquee extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    const carousel = new Splide(this.querySelector('.splide'), {
      arrows: false,
      pagination: false,
      autoWidth: true,
      type: 'loop',
      gap: 'var(--spacing-3xl)',
    });

    carousel.mount(window.splide.Extensions);
  }
}

customElements.define('section-marquee', Marquee);
